export default __webpack_public_path__ + "static/media/whatsapp.62104445.svg";